/**
 * App Navigation Component
 * Uses App Bridge ui-nav-menu for embedded app navigation
 */

import { useSearchParams } from 'react-router';

interface NavItem {
  label: string;
  href: string;
}

interface AppNavProps {
  items: NavItem[];
}

export function AppNav({ items }: AppNavProps) {
  const [searchParams] = useSearchParams();
  const queryString = searchParams.toString();

  if (items.length === 0) {
    return null;
  }

  return (
    <ui-nav-menu>
      {items.map((item) => {
        const href = `${item.href}${queryString ? `?${queryString}` : ''}`;

        return (
          <a key={item.href} href={href}>
            {item.label}
          </a>
        );
      })}
    </ui-nav-menu>
  );
}
